var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.b()},[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:_vm.b('chart-container')},[_c('linear-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.chartopts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }